import React from 'react';
import { message } from 'antd';
import PageWrap from '../../components/PageWrap';
import SuperForm from '../../components/SuperForm';
import TableDOM from '../../components/Table';
import AuthButton from '../../components/AuthButton/AuthButton';
import { shortMsgStatus } from '../../axios/dictionaries';
import { postFrom, config, transterQuery } from '../../axios';
import moment from 'moment';
import { handleExportParams } from '../../utils/index';

export default class Page extends React.Component {
    constructor() {
        super();

        this.state = {
            loading: false, //页面加载中
            current: 1, //当前页
            tableData: [], //表格数据
            tableLoading: false, //表格加载中
            tableTotal: 0, //表格总数据量
            tableSelectedRows: [], //表格选中的行
            params: {
                createTimeStart: "",
                createTimeEnd: "",
                phone: "",
                status: "",
                pageSize: 10,
            },
            inputSearchTerm: "175px", //查询条件宽度
        }
    }

    componentDidMount() {
        this.handleSearch();
    }

    handleSearch = (values = {}) => {   //表单搜索/分页
        let { params, current } = this.state;
        let data = {};
        if (values.current) {
            data = Object.assign({}, params, values);
        } else {
            data = Object.assign({}, params, values, { current });
        }
        this.setState({ params: Object.assign({}, params, values), tableLoading: true });
        postFrom({ url: config.API_smslog_findPage, data }).then(res => {
            this.setState({ tableData: res.records, current: res.current, tableTotal: res.total, tableLoading: false })
        }).catch(err => {
            message.error(err.message || '获取列表失败');
            this.setState({ tableLoading: false });
        })
    }
    render() {
        let {
            loading,
            current,
            tableData,
            tableLoading,
            tableTotal,
            inputSearchTerm
        } = this.state;

        return (
            <PageWrap
                loading={loading}
            >
                <SuperForm
                    data={searchData(inputSearchTerm)}
                    sumbit={this.handleSearch}
                    addParams={'current'}
                />
                <div className="search-btn-list template-style">
                    <AuthButton authkey="j-1-2" type="primary" icon="export" href={`${config.API_smslog_smslogExprot}?${transterQuery(Object.assign({}, handleExportParams() || {}, this.state.params, { current }))}`}>
                        导出
                    </AuthButton>
                </div>
                <TableDOM
                    columns={columns({ current })}
                    data={tableData}
                    loading={tableLoading}
                    total={tableTotal}
                    current={current}
                    onChange={this.handleSearch}
                />
            </PageWrap>
        )
    }

    handleSelectChange = (selectedRowKeys, selectedRows) => { //表格选中行
        this.setState({ tableSelectedRows: selectedRows });
    }
}

const searchData = (inputSearchTerm) => [
    {
        tagName: 'DatePicker',
        formConfig: { name: 'createTimeStart' },
        attribute: { placeholder: '请选择发送开始日期', style: { width: "172.7px" } },
    },
    {
        tagName: 'DatePickerEnd',
        formConfig: { name: 'createTimeEnd' },
        attribute: { placeholder: '请选择发送结束日期', style: { width: "172.7px" } },
    },
    {
        tagName: 'Input',
        formConfig: { name: 'phone' },
        attribute: { placeholder: '输入手机号码', style: { width: inputSearchTerm } }
    },
    {
        tagName: 'Select',
        formConfig: { name: 'status' },
        attribute: { placeholder: '请选择发送状态', style: { width: inputSearchTerm } },
        optionData: [{ title: '全部', value: '' }].concat(shortMsgStatus),
        notResult: '',
    }
];
const columns = ({ current }) => [
    {
        title: '发送时间',
        dataIndex: 'createTime',
        render(text, record, index) {
            return <span>
                <div>{record.createTime ? moment(record.createTime).format('YYYY-MM-DD hh:mm:ss') : ""}</div>
            </span>
        }
    },
    // {
    //     title: '姓名',
    //     dataIndex: 'name',
        // render(text, record, index) {
        //     return <span >
        //     <div>{record.name ? record.name : null}</div>
        // </span>
        // }
    // },
    {
        title: '手机号码',
        dataIndex: 'phone',

        render(text, record, index) {
            return <span >
                <div>{record.phone ? record.phone : null}</div>
            </span>
        }
    },
    {
        title: '短信内容',
        dataIndex: 'content',
        width: 350,

        render(text, record, index) {
            return <span >
                <div>{record.content ? record.content : null}</div>
            </span>
        }
    },
    {
        title: '发送状态',
        dataIndex: 'status',

        render(text, record, index) {
            let now = shortMsgStatus.find(item => item.value === text);
            return <span >
                <div>{now.title}</div>
            </span>
        }
    },
    {
        title: '失败原因',
        dataIndex: 'message',

        render(text, record, index) {
            return <span >
                <div>{record.message ? record.message : null}</div>
            </span>
        }
    },
];



// WEBPACK FOOTER //
// ./src/page/Other/Short.js